export const RPC_PROFILE_ENDPOINTS = {
    GET: "/get_influencer_profile",
    UPDATE: "/update_influencer_profile",
};


